import { SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { JoinLandingPage } from '@presentation/pages';

export const JoinLandingPageController = () => {
  const { translate, routeLocationDescriptor } = useRouter();

  return (
    <>
      <SeoController
        title={translate('signup.breeder.seo.title')}
        description={translate('signup.breeder.seo.description')}
        keywords={translate('signup.breeder.seo.keywords')}
      />
      <JoinLandingPage
        joinBanner={{
          buyerLink: routeLocationDescriptor('joinBuyer'),
          breederLink: routeLocationDescriptor('joinBreeder'),
          shelterLink: routeLocationDescriptor('joinShelter'),
          vetLink: routeLocationDescriptor('joinVet'),
          groomerLink: routeLocationDescriptor('joinGroomer'),
          educatorLink: routeLocationDescriptor('joinEducator'),
        }}
      />
    </>
  );
};
